import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3226dffe"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Clinic Login")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Login ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Back to Patient Login ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginPageHeader = _resolveComponent("LoginPageHeader")!
  const _component_HeaderLogo = _resolveComponent("HeaderLogo")!
  const _component_BaseInput = _resolveComponent("BaseInput")!
  const _component_PasswordField = _resolveComponent("PasswordField")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_CorporateFooter = _resolveComponent("CorporateFooter")!
  const _component_PageWrapper = _resolveComponent("PageWrapper")!

  return (_openBlock(), _createBlock(_component_PageWrapper, null, {
    "content-header": _withCtx(() => [
      _createVNode(_component_LoginPageHeader)
    ]),
    "content-center": _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
      }, [
        _createVNode(_component_HeaderLogo, null, {
          right: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(_component_BaseInput, {
          compact: "",
          "padding-left": "",
          type: "email",
          "icon-left": "icon-mail",
          autocapitalize: "off",
          placeholder: "Please enter your email address",
          label: "Please enter your email address",
          hideLabel: true,
          error: _ctx.hasFormError,
          id: "email",
          onInput: _ctx.setEmail,
          valid: _ctx.isValidEmail
        }, null, 8, ["error", "onInput", "valid"]),
        _createVNode(_component_PasswordField, {
          error: _ctx.hasFormError,
          value: _ctx.password,
          hideLabel: true,
          placeholder: "Password",
          label: "Password",
          onInput: _ctx.setPassword
        }, null, 8, ["error", "value", "onInput"]),
        _createVNode(_component_BaseButton, {
          type: "submit",
          color: _ctx.ButtonColor.PRIMARY,
          pattern: _ctx.ButtonColorPattern.FILL,
          danger: _ctx.hasFormError,
          disabled: !_ctx.canSubmit
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["color", "pattern", "danger", "disabled"]),
        _createVNode(_component_BaseButton, {
          pattern: _ctx.ButtonColorPattern.TRANSPARENT,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$mhaRouterPush(_ctx.Route.Login.Home)))
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["pattern"])
      ], 32)
    ]),
    "content-bottom": _withCtx(() => [
      _createVNode(_component_CorporateFooter)
    ]),
    _: 1
  }))
}